import patchStateReducer from '@coxy/utils/src/redux/patch-state'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type {
  ModelConfigCountryItem,
  ModelConfigVcardLimit,
  ModelInnerConfigAppResponse,
  ModelInnerConfigGlobalResponse,
} from './models/config'
import { ConfigStatus } from './models/types'

export const storeKey = '@redux/config'

export type ConfigState = {
  // Mobile app configuration
  appConfig: ModelInnerConfigAppResponse['data']
  appConfigStatus: ConfigStatus

  // Application state configuration (features/toggles)
  globalConfigStatus: ConfigStatus
  globalConfig: ModelInnerConfigGlobalResponse | null
  countries: ModelConfigCountryItem[]
  countriesStatus: ConfigStatus
  countryConfig: ModelConfigCountryItem | null
  countryConfigStatus: ConfigStatus
  vcardLimits: ModelConfigVcardLimit[]
  vcardLimitsStatus: ConfigStatus
  // Reserved: explorers status (kept for backward compatibility if used elsewhere)
  explorersStatus: ConfigStatus
}

const initialState: ConfigState = {
  // Mobile
  appConfigStatus: ConfigStatus.loading,
  appConfig: {} as ModelInnerConfigAppResponse['data'],
  // App
  globalConfigStatus: ConfigStatus.loading,
  globalConfig: null,
  countries: [],
  countriesStatus: ConfigStatus.loading,
  countryConfig: null,
  countryConfigStatus: ConfigStatus.loading,
  vcardLimits: [],
  vcardLimitsStatus: ConfigStatus.loading,
  // Other
  explorersStatus: ConfigStatus.loading,
}

export const whitelist = ['config', 'appConfig', 'countries', 'countryConfig', 'vcardLimits']

export const configSlice = createSlice({
  name: storeKey,
  initialState,
  reducers: {
    patchConfigState: (state, action: PayloadAction<Partial<ConfigState>>) => patchStateReducer(state, action),
  },
})

export const { patchConfigState } = configSlice.actions
